import script from "./DateQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./DateQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./DateQuestion.vue?vue&type=style&index=0&id=aff0e25a&lang=scss"

const __exports__ = script;

export default __exports__